const jsAppendixTrigger = '.materials--static-in-column .js-appendix'; //Селектор кнопки показать/скрыть приложения
const jsAppendixList = '.materials--static-in-column .js-appendix-list'; //Селектор списка приложений
const $jsAppendixTrigger = $(jsAppendixTrigger); //jquery object кнопки показать/скрыть приложения
const $jsAppendixList = $(jsAppendixList); //jquery object списка приложений

//Функция показать/скрыть материалы
function toggleAppendix() {
	const $this = $(this);
	if ($this.hasClass('is-expand')) {
		$.Velocity($jsAppendixList, 'transition.slideRightOut', 200)
			.then(function () {
				$this
					.removeClass('is-expand')
					.siblings('.js-appendix-list')
					.removeClass('is-expand');
			})
			.catch(err => console.error(err));
	} else {
		$this
			.addClass('is-expand')
			.siblings('.js-appendix-list')
			.addClass('is-expand')
			.velocity('transition.slideRightIn', 200);
	}
}

//Обработчики событий
$jsAppendixTrigger.on('click', function () {
	event.preventDefault();
	toggleAppendix.apply(this);
});

$(document).on('click', function (event) {
	if (!$(event.target).closest(jsAppendixTrigger + ', ' + jsAppendixList).length) {
		$.Velocity($jsAppendixList, 'transition.slideRightOut', 200)
			.then(function () {
				$jsAppendixTrigger
					.removeClass('is-expand')
					.siblings('.js-appendix-list')
					.removeClass('is-expand');
			})
			.catch(err => console.error(err));
	}
});



// WEBPACK FOOTER //
// ./temp/components/social-services/static-in-line/index.js